
import { defineComponent } from 'vue'
import MachinationsLightPage from '~/domain/pages/MachinationsLightPage'
import { PageData } from '~/domain/interfaces/PageDataTypes'
import AupHero from '~/components/aup/AupHero.vue'
export default defineComponent({
  name: 'AcceptableUsePolicyPage',
  components: { AupHero },
  extends: MachinationsLightPage,
  layout: 'machinations',

  head() {
    // @ts-ignore
    const pageHead = this.pageHead()
    const pageData = this.pageData as PageData
    const yoastDescription = pageData?.yoast_head_json?.description
    return {
      ...pageHead,
      title: `Acceptable Use Policy`,
      meta: [
        {
          hid: 'og:title',
          name: 'og:title',
          content: 'About',
        },
        {
          hid: 'description',
          name: 'description',
          content: yoastDescription,
        },
        {
          hid: 'og:description',
          name: 'og:description',
          content: yoastDescription,
        },
        ...pageHead?.meta,
      ],
    }
  },
  async asyncData(context) {
    const { store } = context

    await store.dispatch('common/setupPageLight', { context })

    const pageData = await store.dispatch('wp/fetchPageBySlug', {
      context,
      slug: 'aup',
    })
    store.commit('common/isBusy', false)

    return {
      pageData,
    }
  },
})
